import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import UserRateUpdateServicesSelect from "./UserRateUpdateServicesSelect";
import { Alert } from "@material-ui/lab";
import axios from "axios";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import DefaultButton from "../../../styles/materialButtonStyle";

import { StyledBlockAction, StyledBlockLabel, StyledFormBlock, StyledInputBlock } from "../../../styles/styledTabsForm";
import { parseAxiosError } from "../../../../utils/response";
import { STANDARD_ERRORS_WAY } from "../../../../utils/consts";

const RatesEditService = ({ rate, setRate, notification, setNotification }) => {

  const { t } = useTranslation("ratesPage");
  const [currentRateUpdateService, setCurrentRateUpdateService] = useState(null);

  const updateRateService = () => {
    axios.put("/api/update-rate-base/" + rate.id, { rateBase: currentRateUpdateService.id }, userAuthenticationConfig(false)).then(response => {
      if (response.status === 200) {
        setRate(response.data);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  if (!rate) {
    return null;
  }

  if (rate.length === 0) {
    return <Alert severity="warning">{t("rates.details.changeForm.emptyData")}</Alert>;
  }

  return (
    <StyledFormBlock>
      <StyledBlockLabel>
        {t("rates.details.changeForm.service")}
      </StyledBlockLabel>
      <StyledInputBlock>
        <UserRateUpdateServicesSelect
          checkedService={currentRateUpdateService ?? rate?.rateBase}
          setCheckedService={setCurrentRateUpdateService}
        />
        <StyledBlockAction>
          <DefaultButton
            color="success"
            disabled={!currentRateUpdateService}
            onClick={updateRateService}
          >
            {t("rates.details.changeForm.save")}
          </DefaultButton>
        </StyledBlockAction>
      </StyledInputBlock>
    </StyledFormBlock>
  );
};

export default RatesEditService;